
import skills from '../Assets/links/skills.png';
import avatar from '../Assets/lameck.jpeg';
import home from '../Assets/links/home.png';
import about from '../Assets/links/about.png';
import projects from '../Assets/links/projects.png';
import resume from '../Assets/links/resume.png';
import contact from '../Assets/links/contact.png';
import useMenu from '../Hooks/menuContext';


function Sidebar() {
    const {open, setOpen} = useMenu();
    const scrollToElementById = (id)=>{
         const element = document.getElementById(id).offsetTop - 50;
         window.scroll({ top: element, behavior: "smooth" });
    }
    const handleClick=()=>{
        setOpen(open ===!open)
    }

  return (
    <div className='sidebar'>
        <div className="details">
            <img src={avatar} alt="lamecks pic"/>
            <h3>Lameck Meshack</h3>
            <p>Software Engineer</p>
        </div>
        <div className="links">
            <div className='fs' onClick={() => scrollToElementById('home')} >
                <img className='icon ' src={home} alt="home"/>
                <p onClick={handleClick} >Home</p>
            </div>
            <div onClick={() => scrollToElementById('about')} >
                <img className='icon' src={about} alt="about"/>
                <p onClick={handleClick} >About</p>
            </div>
            <div onClick={() => scrollToElementById('projects')}>
                <img className='icon' src={projects} alt="projects"/>
                <p onClick={handleClick} >Projects</p>
            </div>
            <div onClick={() => scrollToElementById('skills')}>
                <img className='icon' src={skills} alt="skills"/>
                <p onClick={handleClick} >Skills</p>
            </div>
            <div onClick={() => scrollToElementById('resume')} >
                <img className='icon' src={resume} alt="resume"/>
                <p onClick={handleClick} >Resume</p>
            </div>
            <div onClick={() => scrollToElementById('contact')}>
                <img className='icon' src={contact} alt="contact"/>
                <p onClick={handleClick} >Contact</p>
            </div>
        </div>
    </div>
  )
}

export default Sidebar